import { render, staticRenderFns } from "./PromotionalItemUserRequests.vue?vue&type=template&id=4714c72e&"
import script from "./PromotionalItemUserRequests.vue?vue&type=script&lang=js&"
export * from "./PromotionalItemUserRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports